import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { green, orange } from "@mui/material/colors";

import { getDatetimeStringArray } from "../utils/utils";
import Grid from "@mui/material/Grid";
import { PRINT_MODE_EXCLUDE_HEADER } from "./SiteHeader";
import { ScreenStatusContext } from "../context/ScreenStatusContext";
import { useContext, useEffect } from "react";

function CommonTitledPage({ hideCurrentTime, ...props }) {
  const getCurrentTimeString = () => {
    const dtArray = getDatetimeStringArray(new Date());
    return `${dtArray.year}年${dtArray.month}月${
      dtArray.date
    }日 ${dtArray.hour.padStart(2, "0")}:${dtArray.minute.padStart(
      2,
      "0"
    )}:${dtArray.second.padStart(2, "0")} 現在`;
  };

  // 画面ステータスをcontextから取得
  const { setChanged } = useContext(ScreenStatusContext);

  // 画面の初期表示時、入力変更をfalseに設定
  useEffect(() => {
    setChanged(false);
  }, []);

  return (
    <Box marginTop={-1}>
      <Box
        position="sticky"
        width="100%"
        top={56}
        sx={{ zIndex: 99 }}
        className={
          props.printMode && props.printMode === PRINT_MODE_EXCLUDE_HEADER
            ? "print_exclude"
            : ""
        }
      >
        <Paper
          sx={{
            backgroundColor: props.titleColor,
            marginLeft: 1,
            marginRight: 1,
            padding: 1,
          }}
        >
          <Grid container alignItems="center">
            <Grid item xs>
              <Typography fontSize={20}>{props.title}</Typography>
            </Grid>
            <Grid item xs="auto">
              <Typography>
                {!hideCurrentTime && getCurrentTimeString()}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Box>

      <Box margin={2}>{props.children}</Box>
    </Box>
  );
}

// 青果側サイト　ページタイトル
export function CompanyTitledPage(props) {
  return (
    <CommonTitledPage
      titleColor={green[50]}
      title={props.title}
      printMode={props.printMode}
      {...props}
    >
      {props.children}
    </CommonTitledPage>
  );
}

// 青果側サイト　ページタイトル
export function CustomerTitledPage(props) {
  return (
    <CommonTitledPage
      titleColor={green[50]}
      title={props.title}
      printMode={props.printMode}
      {...props}
    >
      {props.children}
    </CommonTitledPage>
  );
}
